__turbopack_context__.v({
  "callOut": "CallOut-module-scss-module__HXsu9q__callOut",
});
